import { Component, OnInit } from '@angular/core';
import { Global } from '../global';
import { Components } from '../shared/components/components';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Funcoes } from '../funcoes';
import { LoginService } from 'app/login/login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { AssinantesService } from '../assinantes/assinantes.service';

declare let swal, $: any;

@Component({
  selector: 'app-relatorio-rmcv-certificados-nacionais',
  templateUrl: './relatorio-rmcv-certificados-nacionais.component.html'
})
export class RelatorioRmcvCertificadosNacionaisComponent extends Components implements OnInit {

  form: FormGroup;
  filtroPesquisa = { data_de: '', data_ate: '', id_assinante: null };
  alturaTela;
  urlPDF = '';
  listAssinantes = [];
  privilegioUsuario = { editar: false, consultar: false };

  constructor(
    formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService,
    private assinantesService: AssinantesService,
    private _location: Location
  ) {
    super();
    this.alturaTela = window.screen.availHeight - 250;

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8) + '01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if (idAcao === '20' || acaoUrl === 'prestacao-mapa' || acaoUrl === 'certificados-nacionais' || acaoUrl === 'mercado-interno') {
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if (this.func.userIsMaster()) {
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });

    this.form = formBuilder.group({
      data_de: ['', [Validators.required]],
      data_ate: ['', [Validators.required]],
      id_assinante: [null]
    });
  }

  ngOnInit() {
    this.carregaAssinantes();
  }

  carregaAssinantes() {
    this.assinantesService.get(['usuario'])
      .subscribe(
        json => {
          this.listAssinantes = [];
          if (json.Payload) {
            for (let i in json.Payload) {
              if (json.Payload[i].usuario) {
                this.listAssinantes.push({
                  'id_assinante': json.Payload[i].id_assinante,
                  'nome': json.Payload[i].usuario.nome
                });
              }
            }
            if (this.listAssinantes.length > 0 && !this.filtroPesquisa.id_assinante) {
              this.filtroPesquisa.id_assinante = this.listAssinantes[0].id_assinante;
            }
          }
        },
        error => {
          this.func.showErro(error.json());
        }
      );
  }

  gerarRelatorio() {
    let assinanteParam = this.filtroPesquisa.id_assinante ? '/' + this.filtroPesquisa.id_assinante : '';
    let url = this.global.dominio_site + '/adm/certificados-nacionais/gerar-relatorio-rmcv/' +
      this.filtroPesquisa.data_de + '/' + this.filtroPesquisa.data_ate + assinanteParam +
      '?tk=' + localStorage.getItem('token');

    window.open(url, '_blank');
  }

  voltar() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/relatorio-rmcv-certificados-nacionais.component.ts